const namespaceCache: Record<string, string> = {}

export function inferNamespace() {
  if (typeof window !== 'undefined') {
    return 'client';
  }

  const error = new Error()
  const stack = error.stack || ''
  const callerLine = stack.split('\n')[2] // Assuming this function is called directly by the logger creation

  if (callerLine && namespaceCache[callerLine]) {
    return namespaceCache[callerLine];
  }

  let namespace = 'unknown'

  if (callerLine) {
    const match = callerLine.match(/\((.*):\d+:\d+\)/) || callerLine.match(/at (.*):\d+:\d+/)
    if (match && match[1]) {
      namespace = match[1]
        .replace(process.cwd(), '') // Remove the project root path
        .replace(/^\/src\//, '') // Remove leading /src/
        .replace(/\.[^/.]+$/, '') // Remove file extension
        .replace(/\//g, '.') // Replace / with .
        .replace(/^\./, '') // Remove leading .
    }
  }

  namespaceCache[callerLine] = namespace
  return namespace
}